import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { FEATURE_MODULES } from '@/constants/feature-modules';
import { useIsFeatureModuleEnable } from '@/utils/useIsFeatureModuleEnable';

type ComplianceModuleGateProps = {
  children: ReactNode;
};

/** Prevents direct navigation when the company has not enabled Compliance. */
export function ComplianceModuleGate({ children }: ComplianceModuleGateProps) {
  const enabled = useIsFeatureModuleEnable(FEATURE_MODULES.Compliance);
  return enabled ? children : <Navigate to="/unauthorized" replace />;
}
